import styles from './LPFooter.module.scss'

const LPFooter: React.FC = () => {
  return (
    <>
      <section className={styles.LPFooter}>
        <div className={styles.footer}>
          <div className={styles.address_group}>
            <img src="/img/common/logo_aitria.svg" className={styles.aitriaLogo} alt="Aitria" />
            <p className={styles.address}>〒107-0052</p>
            <p className={styles.address}>東京都港区赤坂八丁目１番22号 NMF青山一丁目ビル３階</p>
            <div className={styles.button}>
              <a
                href="https://www.google.co.jp/maps/place/Aitria+Co.,+Ltd./@35.673452,139.727701,17z/data=!3m2!4b1!5s0x60188b5ee42ea6b7:0xf9440bc4b8f6a3d5!4m6!3m5!1s0x60188ca66b638993:0x422d4622e50c7d!8m2!3d35.673452!4d139.727701!16s%2Fg%2F1hc134bxp?hl=ja&entry=ttu"
                rel="noopener noreferrer"
                target="_blank"
                className={styles.toGoogleMap}
              >
                <img className={styles.pin} src="/images/lp2/GoogleMapPin.svg" alt="GoogleMap" />
                Google Map
              </a>
            </div>
          </div>
          <div className={`${styles.link_group}`}>
            <a href="/service/" target="_blank" rel="noopener">
              <span className={`${styles.page_cotegoryLink} ${styles.title}`}>Services</span>
            </a>
            <div className={styles.link_text_group}>
              <ul className={`${styles.line}`}>
                <li>
                  <a href="/services/servicedesign" target="_blank" rel="noopener">
                    <span className={styles.link_text}>サービスデザイン</span>
                  </a>
                </li>
                <li>
                  <a href="/services/mobileapp" target="_blank" rel="noopener">
                    <span className={styles.link_text}>モバイルアプリ</span>
                  </a>
                </li>
                <li>
                  <a href="/services/cloudservice" target="_blank" rel="noopener">
                    <span className={styles.link_text}>クラウド活用サービス</span>
                  </a>
                </li>
              </ul>
              <ul className={`${styles.line}`}>
                <li>
                  <a href="/services/designsprint" target="_blank" rel="noopener">
                    <span className={styles.link_text}>デザインスプリント</span>
                  </a>
                </li>
                <li>
                  <a href="/services/frontend" target="_blank" rel="noopener">
                    <span className={styles.link_text}>フロントエンド</span>
                  </a>
                </li>
                <li>
                  <a href="/services/growthhack" target="_blank" rel="noopener">
                    <span className={styles.link_text}>サイト改善ソリューション</span>
                  </a>
                </li>
              </ul>
              <ul className={`${styles.line}`}>
                <li>
                  <a href="/services/uiuxdesign" target="_blank" rel="noopener">
                    <span className={styles.link_text}>UX/UIデザイン</span>
                  </a>
                </li>
                <li>
                  <a href="/services/webapp" target="_blank" rel="noopener">
                    <span className={styles.link_text}>ウェブアプリ</span>
                  </a>
                </li>
                <li>
                  <a href="/services/appgrowth" target="_blank" rel="noopener">
                    <span className={styles.link_text}>プロダクトグロース・UX改善支援</span>
                  </a>
                </li>
              </ul>
              <ul className={`${styles.line}`}>
                <li>
                  <a href="/services/od" target="_blank" rel="noopener">
                    <span className={styles.link_text}>組織開発・イノベーション</span>
                  </a>
                </li>
                <li>
                  <a href="/services/xr" target="_blank" rel="noopener">
                    <span className={styles.link_text}>xR/アプリ開発</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className={`${styles.normal_text} ${styles.page_inkline}`}>
              <a href="/case" target="_blank" rel="noopener">
                <span className={styles.page_cotegoryLink}>Case</span>
              </a>
              <a href="/about" target="_blank" rel="noopener">
                <span className={styles.page_cotegoryLink}>About</span>
              </a>
              <a href="/topics/all/page/1" target="_blank" rel="noopener">
                <span className={styles.page_cotegoryLink}>Topics</span>
              </a>
              <a href="/recruit" target="_blank" rel="noopener">
                <span className={styles.page_cotegoryLink}>Recruit</span>
              </a>
              <a href="/download" target="_blank" rel="noopener">
                <span className={styles.page_cotegoryLink}>Download</span>
              </a>
              <a href="/contact" target="_blank" rel="noopener">
                <span className={styles.page_cotegoryLink}>Contact</span>
              </a>
            </div>
          </div>
        </div>
        <div className={styles.privacyCopylink}>
          <a className={styles.privacyPolicy} href="/privacy" target="_blank" rel="noopener">
            プライバシーポリシー
          </a>
          <p className={styles.copyright}>© Aitria Co., Ltd.</p>
        </div>
      </section>
    </>
  )
}

export default LPFooter
